module.exports = __webpack_public_path__ + "static/media/ladies_accessories_7.664dde61.jpg";